export default window.__STATE__ || {
  appleAuth: {
    clientId: 'com.pocket.test',
    scope: '',
    redirectURI: 'https:\/\/app-test\/connect\/apple\/check',
    state: '12345'
  }
}
